<div class="col-12 p1">
    @if (isOpenNow) {
    <p>
        <span class="col-3 p-r-6 pos-relative dot">{{'Open' | translate}}</span>
        @if (store.todayOpeningHours) {
        {{'Closes at' | translate}} {{store.todayOpeningHours.close | hourFormat12 : ''}}
        }
    </p>
    } @else {
    <p>
        <span class="col-12 p-r-9 pos-relative dot">{{'Closed' | translate}}</span>
        @if (nextOpenStatus) {
        {{'Opens' | translate}}&nbsp;{{nextOpenStatus}}
        }
    </p>
    }
</div>